import React, { useState } from "react";
import { Box, Tabs, Tab, IconButton, Tooltip } from "@mui/material";
import { Brightness4, Brightness7 } from "@mui/icons-material";
import { NotificationProvider, PermissionCenterProvider, AuthLayout } from "@1823-partners/core";
import { useThemeMode } from "./theme/ThemeContext";
import api from "./api";
import ScenView from "./components/ScenView";
import ComparisonMode from "./components/ComparisonMode";

const isProd = process.env.REACT_APP_DB_ENV === 'prod';

export default function App() {
  const [activeTab, setActiveTab] = useState(0);
  // Tabs stay mounted once visited (hidden via CSS) so switching back does
  // not unmount the view, lose its state, and refetch /configs + /deals.
  const [comparisonVisited, setComparisonVisited] = useState(false);
  const { mode, toggleTheme } = useThemeMode();

  const handleTabChange = (_, v) => {
    if (v === 1) setComparisonVisited(true);
    setActiveTab(v);
  };

  const themeToggle = (
    <Tooltip title={`Switch to ${mode === 'light' ? 'dark' : 'light'} mode`}>
      <IconButton onClick={toggleTheme} color="inherit" sx={{ mr: 1 }}>
        {mode === 'light' ? <Brightness4 /> : <Brightness7 />}
      </IconButton>
    </Tooltip>
  );

  return (
    <NotificationProvider>
      {/* Mounts the permissions drawer (the toolbar's shield button) and, because it wraps
          PermissionRequestProvider internally, turns the "Request access" button on
          permission-denied toasts into an in-app request. Before this the app mounted no provider
          at all, so that button fell through to its href and sent the user off to the Permissions
          app instead of asking in place. Inside NotificationProvider because the request path
          reports its outcome as a toast. */}
      <PermissionCenterProvider api={api} appName="trade">
      <AuthLayout
        title="Trade App"
        headerContent={themeToggle}
        contentSx={{ p: 0 }}
      >
        {({ userInfo }) => (
          <>
            <Tabs
              value={activeTab}
              onChange={handleTabChange}
              sx={{
                bgcolor: 'background.paper',
                borderBottom: 1,
                borderColor: 'divider',
                px: 3,
                '& .MuiTab-root': {
                  textTransform: 'none',
                  fontWeight: 600,
                  fontSize: '15px',
                  minHeight: 48,
                },
              }}
            >
              <Tab label="Trading" />
              {!isProd && <Tab label="Comparison - BETA" />}
            </Tabs>
            <Box sx={{ p: 3, flex: 1 }}>
              <Box sx={{ display: activeTab === 0 ? 'block' : 'none' }}>
                <ScenView userId={userInfo?.userDetails || 'local'} />
              </Box>
              {!isProd && comparisonVisited && (
                <Box sx={{ display: activeTab === 1 ? 'block' : 'none' }}>
                  <ComparisonMode userId={userInfo?.userDetails || 'local'} />
                </Box>
              )}
            </Box>
          </>
        )}
      </AuthLayout>
      </PermissionCenterProvider>
    </NotificationProvider>
  );
}
